import { Space, Typography } from 'antd';
import Alert from 'components/new-ui/base/alert/Alert';
import Button from 'components/new-ui/base/button/Button';
import { H2 } from 'components/new-ui/base/typography/styles';

type Props = {
    onAddBillingDetails: () => void;
};

const PartyBillingWarning = ({ onAddBillingDetails }: Props) => {
    return (
        <Alert
            showIcon
            type="warning"
            iconAlign="flex-start"
            message={
                <Space size={2} direction="vertical" style={{ width: '100%' }}>
                    <H2>Party Billing Details Missing</H2>
                    <Typography.Text>
                        This party's billing details haven't been set up yet, so the billing email defaults to the
                        contact's email. Add billing details to make sure invoices go to the right place.
                    </Typography.Text>
                    <div>
                        <Button style={{ color: 'var(--brand-6)' }} type="link" onClick={onAddBillingDetails}>
                            Add billing details
                        </Button>
                    </div>
                </Space>
            }
        ></Alert>
    );
};

export default PartyBillingWarning;
